const urls = {

    // General Urls
    NONE                : "",

};

export default urls;
